module.exports = __webpack_public_path__ + "static/media/quizBadgeLevel2Locked.625b047f.png";